if (process.env.NODE_ENV !== 'development')
{
	__webpack_public_path__ = window.config.LOC_RESOURCE + window.config.SITE_ID + '/site_spa/'
}
